// src/components/MaintenanceCalendar.js
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import enUS from 'date-fns/locale/en-US';
import "react-big-calendar/lib/css/react-big-calendar.css";
import HaqtButton from "../../components/HaqtButton/HaqtButton";
import { AppContext } from "../../context/AppContextProvider";
import { Button, Modal, TextField, Box } from '@mui/material';

// Setup the date-fns localizer
const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
});

// Dummy data for events
const initialEvents = [
  {
    title: 'Replace Water Level Sensor Pressure',
    allDay: false,
    start: new Date(2024, 9, 8, 10, 0),  // Example: October 8, 2024
    end: new Date(2024, 9, 8, 12, 0),
    color: '#005572' // Background color for the event (red-orange)
  },
  {
    title: 'Replace Filter A',
    allDay: false,
    start: new Date(2024, 9, 10, 14, 0), // Example: October 10, 2024
    end: new Date(2024, 9, 10, 15, 0),
    color: '#005572' // Background color for the event (red-orange)
  }
];

const MaintenanceCalendar = () => {
  const [events, setEvents] = useState(initialEvents);
  const [newEvent, setNewEvent] = useState({ title: '', start: '', end: '' , color: ''});
  const [open, setOpen] = useState(false);
  const { setBreadcrumbs, setShowSpinner } = useContext(AppContext);
  // Function to apply color to events
    const eventPropGetter = (event) => {
      const backgroundColor = event.color || '#3174ad'; // Default color if not set
      return { style: { backgroundColor } };
    };
  const handleAddEvent = () => {
    setEvents([...events, newEvent]);
    setNewEvent({ title: '', start: '', end: '', color: '' });
    setOpen(false);
  };
  useEffect(() => {
    setBreadcrumbs([
      "Maintenance",
      "Schedule",
    ]);
  }, []);
  return (
    <div>
    <div
    // className="mb-3"
    style={{
      display: "flex",
      justifyContent: "space-between",
    }}
    >
      <h2>Preventive Maintenance Schedule</h2>
      <Button 
      style={{
        background: "#005572",
        color: "white",
        textTransform: "capitalize",
        fontFamily: "Helvetica-Normal",
        maxHeight: "35px",
        width:"120px"
      }}
      variant="contained" onClick={() => setOpen(true)} 
        >
        Add New Task
      </Button>

      </div>

      {/* Calendar displaying events */}
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        eventPropGetter={eventPropGetter}  
        style={{ height: 500, margin: "50px" }}
      />

      {/* Modal to add new maintenance task */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="add-maintenance-task"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h3>Add Maintenance Task</h3>
          <TextField
            fullWidth
            label="Task Title"
            value={newEvent.title}
            onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Start Date and Time"
            type="datetime-local"
            value={newEvent.start}
            onChange={(e) => setNewEvent({ ...newEvent, start: new Date(e.target.value) })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            fullWidth
            label="End Date and Time"
            type="datetime-local"
            value={newEvent.end}
            onChange={(e) => setNewEvent({ ...newEvent, end: new Date(e.target.value) })}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >

              <Button
                variant="outlined"
                type="submit"
               // onClick={formik.handleSubmit}
                style={{
                  background: "#005572",
                  color: "white",
                  textTransform: "capitalize",
                  fontFamily: "Helvetica-Normal",
                }}
              >
                Save
              </Button>

            <Button
              style={{
                textTransform: "capitalize",
                fontFamily: "Helvetica-Normal",
              }}
              variant="outlined"
             // onClick={handleCancel}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default MaintenanceCalendar;
